<template>
  <div class="resume-detail" v-loading="loading">
    <h4 class="job-name">投递职位：{{order.job_name}}</h4>
    <!-- <el-row type="flex" justify="center" style="paddingBottom:55px">
      <el-col :span="22">
        <el-steps :active="current" process-status="finish">
          <el-step
            v-for="item in steps"
            :key="item.title"
            :title="item.title"
            :description="item.time"
          ></el-step>
        </el-steps>
      </el-col>
    </el-row> -->
    <div class="job-info">
      <p>申请职位：{{ order.job_name }}</p>
      <p>申请公司：{{ job.company && job.company.name }}</p>
      <!-- <p>申请时间：{{order.created_at}}</p> -->
    </div>
    <div>
      <Candidate :source="resume"></Candidate>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import Api from "@/api";
import Candidate from '../tabs/candidate'

export default {
  name: 'PartTimeDetail',
  components: {
    Candidate
  },
  props: {
    id: {
      default: -1,
    },
    status:{

    }
  },
  computed: {
    post_id() {
      if (this.id < 0) {
        return this.$route.query.post_id;
      } else {
        return this.id;
      }
    },
    current() {
      let status = this.order.status;
      let arr = [
        ["CREATED", "AUDIT_PASSED", "AUDIT_FAILED", "SUBMIT_FAILED"],
        ["SUBMIT_PASSED", "INTERVIEW", "INTERVIEW_FAILED", "CLOSED"],
        ["OFFERED"],
        ["ENTERED", "NOT_ENTERED"],
        ["COMPLETED", "NOT_COMPLETED"],
        ["UNSETTLED", "SETTLED"]
      ];
      return arr.findIndex(item => item.indexOf(status) > -1);
    },
  },
  data() {
    return {
      loading: false,
      activeTab: '1',
      job: {},
      order: {},
      resume: {},
      steps: [
        { title: '推荐', time: '2020-09-21' },
        { title: '面试', time: '2020-09-21' },
        { title: 'OFFER', time: '2020-09-21' },
        { title: '入职', time: '2020-09-21' },
        { title: '过保', time: '2020-09-21' },
      ],
      viewMoreInfo: false,
    }
  },
  created(){
    this.resumeDetail()
  },
  mounted() {
    
  },
  methods: {
    calcTabs(lines) {
      let tabs = [
        { title: "推荐" },
        { title: "面试" },
        { title: "OFFER" },
        { title: "入职" },
        { title: "过保" },
      ];
      lines.forEach(item => {
        item.post_status == "CREATED" &&
          (tabs[0].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "INTERVIEW" &&
          (tabs[1].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "OFFERED" &&
          (tabs[2].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "ENTERED" &&
          (tabs[3].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "COMPLETED" &&
          (tabs[4].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "SETTLED" &&
          (tabs[4].time = moment(item.created_at).format("YYYY-MM-DD"));
      });
      this.steps = [...tabs];
    },
    //简历详情   
    async resumeDetail(){
      this.loading = true
      try {
        let res = await Api.post.partTimeDetail(this.post_id);
        this.order = res
        this.job = res.job
        this.resume = res.resume
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.resume-detail {
  font-size: 14px;
  padding: 30px 20px;
  .job-name {
    margin-bottom: 20px;
  }
  .job-info {
    line-height: 30px;
    padding-left: 40px;
  }
  .order-info {
    margin: 10px 0 30px;
    border: 1px solid #35b5fe;
    background: rgb(224, 244, 255);
    padding: 15px 20px 2px;
    position: relative;
    font-size: 14px;
    .btn {
      position: absolute;
      cursor: pointer;
      z-index: 10;
      right: 10px;
    }
    .reason {
      color: rgb(238, 88, 88);
      padding-left: 30px;
    }
  }
}
</style>